import React from "react";

const CloseBold = ({ width = "20px", height = "20px", display = "block" }) => (
  <svg
    className={`fill-current ${display}`}
    width={width}
    height={height}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.8995 1.12126C8.50897 0.730738 7.87581 0.730738 7.48528 1.12126L5.01041 3.59614L2.53554 1.12126C2.14501 0.730738 1.51185 0.730738 1.12132 1.12126C0.730799 1.51179 0.730799 2.14495 1.12132 2.53548L3.5962 5.01035L1.12132 7.48522C0.730799 7.87575 0.730799 8.50891 1.12132 8.89944C1.51185 9.28996 2.14501 9.28996 2.53554 8.89944L5.01041 6.42456L7.48528 8.89944C7.87581 9.28996 8.50897 9.28996 8.8995 8.89944C9.29002 8.50891 9.29002 7.87575 8.8995 7.48522L6.42462 5.01035L8.8995 2.53548C9.29002 2.14495 9.29002 1.51179 8.8995 1.12126Z"
      fill=""
    />
  </svg>
);

export default CloseBold;
